import { render, staticRenderFns } from "./generatereport.vue?vue&type=template&id=366b0a48"
import script from "./generatereport.vue?vue&type=script&lang=js"
export * from "./generatereport.vue?vue&type=script&lang=js"
import style0 from "./generatereport.vue?vue&type=style&index=0&id=366b0a48&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports